import { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@interstate/components/AccordionGroup';
import { Typography } from '@interstate/components/Typography';
import { useCustomerCardContext } from '../../CustomerFormContext';
import BusinessInformationFields from './BusinessInformationFields';
import BankInformation from './BankInformation';

/**
 * Collapsible Business Information accordion containing the business detail fields and
 * bank information. Defaults expanded when the buyer already has business data. Migrated from MV.
 */
const BusinessInformation = () => {
    const { hasBusinessData } = useCustomerCardContext();
    const [expanded, setExpanded] = useState(hasBusinessData);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    return (
        <Accordion expanded={expanded} onChange={handleChange} data-testid="business-information-accordion">
            <AccordionSummary chevronPosition="left">
                <Typography
                    variant="anchor-block-md"
                    color="base.color.blue.700"
                    data-testid="business-information-accordion-header"
                    sx={{ textWrap: 'auto' }}
                >
                    Business Information
                </Typography>
            </AccordionSummary>
            <AccordionDetails data-testid="business-information-accordion-content">
                <BusinessInformationFields />
                <BankInformation />
            </AccordionDetails>
        </Accordion>
    );
};

BusinessInformation.displayName = 'BusinessInformation';
export default BusinessInformation;
